// removed by extract-text-webpack-plugin
module.exports = {"loader":"_1HOVd8UKZVGYbNRXCjSAPR","centerX":"_2ILhtrY-1fjLVbznvwh5ku","centerY":"_2mDGd-6yQpsIlWXJJZbgyl"};


//////////////////
// WEBPACK FOOTER
// ./src/UI/Loader/Loader.css
// module id = 622
// module chunks = 3